import { IDivision, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

type Division = {
  name: string;
};

interface ExportParams extends IqueryParams<{
  district_name?: string;
  region_name?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createDivision = async (data: Division) => {
  return apiService.apiRequest<IDivision>("post", `divisions`, data);
};

const getDivisions = async (queryParams?: IqueryParams<{
  district_name?: string;
  region_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IDivision[]>(
    "get",
    `divisions${query}`
  );
};

const getDivision = async (division_id: string) => {
  return apiService.apiRequest<IDivision>("get", `divisions/${division_id}`);
};

const updateDivision = async (division_id: string, data: Division) => {
  return apiService.apiRequest<IDivision>("put", `divisions/${division_id}`, data);
};

const deleteDivision = async (division_id: string) => {
  return apiService.apiRequest<any>("delete", `divisions/${division_id}`);
};

const restoreDivision = async (division_id: string) => {
  return apiService.apiRequest<any>("get", `divisions/${division_id}/restore`);
};

// Export function
const exportDivisions = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `divisions/export${query}`
  );
};


export const divisionsApi = {
  createDivision,
  getDivisions,
  getDivision,
  updateDivision,
  deleteDivision,
  restoreDivision,
  exportDivisions,
};